import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const Div = styled('div')(mapStylesProp);
